import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';

import { LedgerMasterService } from '../../../services/index';
import { AddEditLedgerMasterComponent } from './addEditLedgerMaster.component';

@Component({
    selector: 'ledger-master-tab',
    templateUrl: './ledgerMaster.component.html',
})
export class LedgerMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    ledgerData: any[] = [];
    isLoading: boolean = false;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    filterData = {
        search_data: ''
    };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editTemplate') editTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(
        private ledgerMasterService: LedgerMasterService,
        private modalService: BsModalService,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Ledger Name', prop: 'name', cellClass: 'cell-left', width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Group', prop: 'group_name', cellClass: 'cell-left', width: 180, minWidth: 180, maxWidth: 180 },
            { name: 'Branch', prop: 'branch_name', cellClass: 'cell-left', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Action', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getLedgerMasterList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getLedgerMasterList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getLedgerMasterList();
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getLedgerMasterList();
    }

    getLedgerMasterList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.ledgerMasterService
            .getLedgerMasterList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.ledgerData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onEditLedger(row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);
        this.bsModalRef = this.modalService.show(AddEditLedgerMasterComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = 'Edit';
        this.bsModalRef.content.title = 'Edit Ledger';
        this.bsModalRef.content.ledgerdata = Object.assign({}, row);
        this.bsModalRef.content.ledgerLoadEvent.subscribe(($e) => {
            that.getLedgerMasterList();
        });
    }

    public onViewLedger(row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);
        this.bsModalRef = this.modalService.show(AddEditLedgerMasterComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = 'View';
        this.bsModalRef.content.title = 'View Ledger';
        this.bsModalRef.content.ledgerdata = Object.assign({}, row);
        this.bsModalRef.content.ledgerLoadEvent.subscribe(($e) => { });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/ledgerMaster/ledgerMaster.component.ts